import {
  ItemPageKlarnaPromoDto,
  ItemPageKlarnaPromoPluginModel,
} from '@marketplace-web/domain/checkout-payments-options-data'

export const getItemPageKlarnaPromoPluginModel = (
  klarnaPromoDto: ItemPageKlarnaPromoDto,
): ItemPageKlarnaPromoPluginModel => {
  return {
    showKlarna: klarnaPromoDto?.show_klarna || false,
  }
}
